import React from 'react';
import styles from './TermsPage.module.css';

export default function PrivacyPage() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.date}>Last updated: March 2026</p>
      </div>
      <div className={styles.content}>
        <section className={styles.section}>
          <h2>Information We Collect</h2>
          <p>beryl collects only what you directly enter: your name, recovery start date, pain logs, meal entries, exercise completions, appointment details, and medical documents. No data is collected automatically or shared with third parties.</p>
        </section>
        <section className={styles.section}>
          <h2>How We Use Your Data</h2>
          <p>Your data is used solely to display your recovery progress and provide personalised insights within the app. We do not sell, rent, or share your personal information with anyone.</p>
        </section>
        <section className={styles.section}>
          <h2>Data Storage</h2>
          <p>Your data is stored securely in Supabase with row-level security — only you can access your records.</p>
        </section>
        <section className={styles.section}>
          <h2>Your Rights</h2>
          <p>You can delete your account and all associated data at any time from the Settings screen. You can also request a copy of your data by contacting us.</p>
        </section>
        <section className={styles.section}>
          <h2>Cookies</h2>
          <p>beryl does not use tracking cookies. We only store session data necessary for authentication.</p>
        </section>
        <section className={styles.section}>
          <h2>Medical Disclaimer</h2>
          <p>beryl is a personal tracking tool, not a medical device. It does not provide medical advice. Always consult a qualified healthcare professional for medical guidance.</p>
        </section>
        <section className={styles.section}>
          <h2>Contact</h2>
          <p>For privacy-related questions, please contact us through the app or at the email address on our website.</p>
        </section>
      </div>
    </div>
  );
}
